<ng-container *ngIf="landingPageStatus">
  <kp-landing-header
    [isLoading]="isLoading"
    (getStartedClicked)="proceedWithOnboarding({ title: 'banner' })"></kp-landing-header>
  <kp-landing-section *ngIf="isLoading" [isLoading]="isLoading" class="hero loading"></kp-landing-section>
  <ng-container *ngIf="!isLoading">
    <kp-landing-section
      *ngFor="
        let section of landingPageStatus?.data?.content;
        let first = first;
        let last = last;
        let odd = odd;
        let index = index
      "
      [section]="section"
      [ngClass]="{ flipped: odd, hero: first, last: last }"
      [index]="index"
      [hero]="first"
      (getStartedClicked)="proceedWithOnboarding($event)"></kp-landing-section>
  </ng-container>
  <kp-landing-footer [includeProMedica]="isResourceful" [includeTrademark]="isPurposeful"></kp-landing-footer>
</ng-container>
